import React from 'react';

import { Grid } from '@mui/material';

import CheckedThickIcon from './checked-thick.svg?react';
import ThickIcon from './thick.svg?react';

interface CheckThickListItemProps extends React.PropsWithChildren<unknown> {
  isChecked: boolean;
}

export const CheckThickListItem = ({
  isChecked,
  children,
}: CheckThickListItemProps) => {
  return (
    <Grid flexWrap="nowrap" spacing={2} container>
      <Grid item>{isChecked ? <CheckedThickIcon /> : <ThickIcon />}</Grid>
      <Grid style={{ textAlign: 'left' }} item>
        {children}
      </Grid>
    </Grid>
  );
};
